/** Default UI locale per tenant. Homepage meta (`index.page_title` / `index.desc`) comes from `messages[lang]`, so Gaste Arşivi SSR uses Turkish strings only. */
const TENANT_TO_LANG: Record<string, string> = {
  "gastearsivi": "tr",
  "historyworm": "en"
};

export default TENANT_TO_LANG;
